import { render, staticRenderFns } from "./TemplateC.vue?vue&type=template&id=2cb2fd5c&scoped=true&"
import script from "./TemplateC.vue?vue&type=script&lang=js&"
export * from "./TemplateC.vue?vue&type=script&lang=js&"
import style0 from "./TemplateC.vue?vue&type=style&index=0&id=2cb2fd5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2fd5c",
  null
  
)

export default component.exports